import { type MetagameTokenPackageBundle } from '../../dto/metagames.types';
import type { PackageBundle } from '../app/types';

export const isMetagameTokenPackageBundles = (
  packageBundles: PackageBundle[],
): packageBundles is MetagameTokenPackageBundle[] => {
  return packageBundles.length > 0 && packageBundles.every((bundle) => bundle.bundleType === 'metagameToken');
};
